import { call, put, select } from 'redux-saga/effects';
import { FeedMediaStates, RTCClient } from 'utils/webrtc';
import { interactionTriggered } from 'features/application/actions';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { logger } from 'utils/logger';
import { selectMediaDevicePermissions } from 'features/user-media/userMediaSlice';
import { type PermissionStatus } from 'features/user-media/types';
import { openModal } from 'features/modal/modalSlice';

export function* toggleLocalVideoSaga() {
  const canBroadcastVideo: boolean = yield call(hasPermissionsSaga, PermissionTypes.broadcastVideo);

  if (!canBroadcastVideo) {
    logger.remote().warn('Tried to toggle video without broadcast permission');
    return;
  }

  const camPermissions: PermissionStatus = yield select(selectMediaDevicePermissions, 'videoinput');
  if (camPermissions !== 'granted') {
    logger.remote().warn('Tried to toggle video without media device permission');
    return;
  }

  const mediaStates: FeedMediaStates = yield call(RTCClient.publishingFeed.getMediaStates);
  const enabling = !mediaStates.video.broadcasting;

  yield put(interactionTriggered(enabling ? 'unmuteVideo' : 'muteVideo'));

  yield call(RTCClient.publishingFeed.toggleVideoBroadcasting);

  // A capture denial during enable flips the permission to 'denied' above; open the recovery
  // modal now so it doesn't take a second click to surface.
  if (enabling) {
    const camPermissionsAfter: PermissionStatus = yield select(
      selectMediaDevicePermissions,
      'videoinput'
    );
    if (camPermissionsAfter !== 'granted') {
      yield put(openModal('mediaDevicesBlocked', { video: true, audio: false }));
    }
  }
}
